module.exports = __webpack_public_path__ + "img/gw28803.bc1a6b6e.png";